// src/components/LinkPagoGenerado.js
import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Grid,
  Chip,
  Alert,
} from "@mui/material";
import {
  ContentCopy as CopyIcon,
  Check as CheckIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";

const LinkPagoGenerado = ({
  paymentLink,
  pedido,
  totalGeneral,
  linkCopied,
  onCopiarLink,
  onVolver,
}) => {
  if (!paymentLink) return null;

  const abrirLink = () => {
    window.open(paymentLink.url, "_blank", "noopener,noreferrer");
  };

  return (
    <Box>

      {/* Información del pago */}
      <Paper sx={{ p: 2, mb: 3, border: "1px solid #e0e0e0" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              ID del pago:
            </Typography>
            <Typography variant="body1" fontFamily="monospace" fontSize="0.9rem">
              {paymentLink.external_id || paymentLink.id}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Expira en:
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              7 días
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Link para copiar */}
      <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        Link de pago
      </Typography>

      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 3,
          bgcolor: "grey.50",
          borderRadius: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            fullWidth
            size="small"
            value={paymentLink.url}
            InputProps={{
              readOnly: true,
              sx: {
                fontFamily: "monospace",
                fontSize: "0.85rem",
                backgroundColor: "white",
              },
            }}
            variant="outlined"
          />
          <Button
            variant="contained"
            size="small"
            onClick={onCopiarLink}
            color={linkCopied ? "success" : "primary"}
            startIcon={linkCopied ? <CheckIcon /> : <CopyIcon />}
            sx={{ minWidth: "100px", height: "40px" }}
          >
            {linkCopied ? "Copiado" : "Copiar"}
          </Button>
        </Box>
      </Paper>

      {/* Botón para abrir */}
      <Box sx={{ mb: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={abrirLink}
          fullWidth
          sx={{ py: 1.5 }}
        >
          Abrir link de pago
        </Button>
      </Box>

      {/* Instrucciones */}
      <Alert severity="info">
        <Typography variant="body2">
          Copia el link y compártelo con el cliente.
        </Typography>
      </Alert>

      {/* Feedback de copiado */}
      {linkCopied && (
        <Alert severity="success" sx={{ mt: 2 }}>
          Link copiado al portapapeles
        </Alert>
      )}
    </Box>
  );
};

export default LinkPagoGenerado;